import QueryString from 'qs'
import { isNil, isString } from '../checks'
import normalizeSearchState from '../../domain/search/normalizeSearchState'

export const getSessionStorageSearchState = () => {
  if (typeof window === 'undefined') {
    return {}
  }

  const searchState = sessionStorage.getItem('searchState')

  if (isNil(searchState)) {
    return {}
  }

  const parsedSearchState = JSON.parse(searchState)

  return normalizeSearchState(parsedSearchState)
}

export const getQueryParamSearchState = () => {
  if (typeof window === 'undefined') {
    return {}
  }

  const search = location.search

  if (isNil(search)) {
    return {}
  }

  return normalizeSearchState(QueryString.parse(location?.search.slice(1)))
}

export const getSearchState = () => {
  return getSessionStorageSearchState() || getQueryParamSearchState() || {}
}

export const getSearchStateLocations = () => {
  const refinementListLocations =
    getSearchState()?.refinementList?.locations || []

  return isString(refinementListLocations)
    ? [refinementListLocations]
    : refinementListLocations
}

export const getSearchStateLocationName = () => {
  return getSearchState()?.locationName || ''
}

export const getQueryParamSearchStateLocations = () => {
  const refinementListLocations =
    getQueryParamSearchState()?.refinementList?.locations || []

  return isString(refinementListLocations)
    ? [refinementListLocations]
    : refinementListLocations
}

export const getQueryParamSearchStateLocationName = () => {
  return getQueryParamSearchState()?.locationName || ''
}
